import { Pipe, PipeTransform } from '@angular/core';
import { FormSectionModel } from '../../models/CustomizationSettingsSubmitModel';

@Pipe({
  name: 'sectionVisibleFilter',
  pure: false
})
export class FormSectionVisibleFilterPipe implements PipeTransform {
  transform(sections: FormSectionModel[]): any {
    if (!sections) {
      return
    }
    return sections.filter(section => section.isVisible != false);
  }

}


